// Data that configures the Player Defensive Table
import { defensivePlayerTableRowItems } from '@/utils/dataTablesStructures/normalPlayer';
import { defensiveGoalkeeperTableRowItems } from '@/utils/dataTablesStructures/goalkeeperPlayer';
import baseColumns from '@/data/player/baseColumns';

export default {
  columns: baseColumns,
  expandedRows: defensivePlayerTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
  goalkeeperExpandedRows: defensiveGoalkeeperTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};
